import React from 'react'
import Navbar from '../components/Navbar'
import BreadCrumb from '../components/BreadCrumb'
import Footer from '../components/Footer'
import GalleryPageComponent from '../components/GalleryPageComponent'

import { Helmet } from "react-helmet";
import ScrollNavbar from '../components/ScrollNavbar'

const GalleryPage = () => {
  return (
    <div>

<Helmet>
        <title>FluffyTouch Pet Grooming Gallery | Before & After</title>
        <meta
          name="description"
          content="See amazing before & after pet grooming transformations! Browse our gallery of breed-specific cuts, lion trims & spa treatments. Book your session now!"
        />
      </Helmet>
      
      <ScrollNavbar/>
        <Navbar/>
        <BreadCrumb name="Gallery" title="Fluffy Touch Gallery"/>
<GalleryPageComponent/>
        <Footer/>
        
    </div>
  )
}

export default GalleryPage